export enum UserSettingProperty {
	USER_DEFERRED_MESSAGES_EMAIL_SEND_ENABLED = 'USER_DEFERRED_MESSAGES_EMAIL_SEND_ENABLED',
	USER_WEEKLY_SUMMARY_EMAIL_SEND_ENABLED = 'USER_WEEKLY_SUMMARY_EMAIL_SEND_ENABLED',
	USER_CONNECTION_REMINDER_EMAIL_SEND_ENABLED = 'USER_CONNECTION_REMINDER_EMAIL_SEND_ENABLED',
	USER_MODULE_UNFINISHED_EMAIL_SEND_ENABLED = 'USER_MODULE_UNFINISHED_EMAIL_SEND_ENABLED',
}
